import _validate from "./validate";
import { ElLoading, ElMessage } from 'element-plus';
export default {
  openTip: openTip, // 页面头部弹出的提示
  cloneObj: cloneObj, // 深度拷贝对象
  retain: retain, // 保留两位小数
  resetPage: resetPage, // 充值page数据
  getUrlParamValue: getUrlParamValue, // 从URL中根据参数名称获取参数值
  upload: upload, // 下载
  getTime: getTime, // 获取时间
  getTimeYDM: getTimeYDM, // 获取时间年月日
  loading: loading, // 加载
  copy: copy, // 复制
  debounceFn: debounceFn, // 函数防抖
  throttle: throttle, // 函数节流
  brightKeyword: brightKeyword, // 搜索关键词高亮显示
  pinyinSort: pinyinSort, // 省市区按照拼音排序分类
  pinyinCountrySort: pinyinCountrySort, // 国家按照拼音排序分类
  deepClone: deepClone, // 深度克隆对象
  genWts: genWts, // 委托书类型
  uuid: uuid, // 获取uuid
}

/** 提示信息
 * @param vm
 * @param message { String } -必选 提示内容
 * @param type { String } -可选 提示信息的类型 失败：error 警告：warning 成功：success 默认为消息
 */
function openTip(vm, msg, type) {
  vm.$message({
    message: msg,
    showClose: true, // { Boolean  } -可选 提示信息是否可手动关闭
    type: type
  })
}

/* 深度拷贝对象 */
function cloneObj(obj) {
  var str; var newobj = obj.constructor === Array ? [] : {}
  if (typeof obj !== 'object') {
    return
  } else if (window.JSON) {
    str = JSON.stringify(obj), // 序列化对象
      newobj = JSON.parse(str) // 还原
  } else {
    for (var i in obj) {
      newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i]
    }
  }
  return newobj
}

// 分转元换算
function retain(data, num) {
  if (data == undefined || data == null || data == '' || data == 0) {
    data = 0
  } else {
    data = (data / 100).toFixed(num)
  }
  return data
}

/**
 * @param {*} url 重置page数据
 */
function resetPage() {
  let page = {
    pageNo: 1,
    pageSize: 10,
    total: 1,
    currentPage: 1,
  }
  return page
}

function getUrlParamValue(url, paramName) {
  if (url.indexOf("?") < 1) {
    return null;
  }
  let paramStr = url.substr(url.indexOf("?") + 1);
  let paramList = paramStr.split("&");
  if (_validate.checkListEmpty(paramList)) {
    return null;
  }
  let currParamStr = "";
  let currParamList = null;
  let currKey = "";
  let currValue = "";
  for (let cnt = 0; cnt < paramList.length; cnt++) {
    currParamStr = paramList[cnt];
    if (_validate.checkEmptyTrim(currParamStr)) {
      continue;
    }
    if (currParamStr.indexOf("=") < 1) {
      continue;
    }
    currParamList = currParamStr.split("=");
    if (_validate.checkListEmpty(currParamStr)) {
      continue;
    }
    if (currParamList.length != 2) {
      continue;
    }
    currKey = currParamList[0];
    currValue = currParamList[1];
    if (currKey == paramName) {
      return currValue;
    }
  }
  return null;
}

/**
 * element-table 下载
 * data 需要下载的表格数据
 * name 表格名称
 * obj 自定义表格的时候表头显示不出来
 * obj{key: C1, name: "value"}
 * key 列数A-B-C-D方式排列
 * name 需要修改成的字段名称
 */
function upload(vm, data, name, obj) {
  let table_book = vm.$XLSX.utils.table_to_book(data);
  if (_validate.checkEmpty(name)) {
    name = "Sheet"
  }
  if (obj) {
    table_book.Sheets.Sheet1[obj.key].t = "s"
    table_book.Sheets.Sheet1[obj.key].v = "支出"
  }
  var table_write = vm.$XLSX.write(table_book, {
    bookType: "xlsx",
    bookSST: true,
    type: "array"
  });
  try {
    vm.$FileSaver.saveAs(
      new Blob([table_write], { type: "application/octet-stream" }),
      name + ".xlsx"
    );
  } catch (e) {
    if (typeof console !== "undefined") console.log(e, table_write);
  }
  return table_write;
}

//  20191022151547576  这样格式的时间
function getTime() {
  let myDate = new Date();
  let value = myDate.getFullYear() + "" + (myDate.getMonth() + 1) + "" + myDate.getDate() + "" + myDate.getHours() + "" + myDate.getMinutes() + "" + myDate.getSeconds() + "" + myDate.getMilliseconds()
  return value
}

// 获取时间年月日
function getTimeYDM() {
  let myDate = new Date();
  let value = myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getDate()
  return value
}
/**
 * 加载
 * time 时间毫秒
 */
function loading(time = 500) {
  let loadingInstance = ElLoading.service({
    text: "拼命加载中"
  });
  setTimeout(() => {
    loadingInstance.close();
  }, time);
}

/**
 * 复制
 * data 需要复制的数据
 */
function copy(data) {
  if (_validate.checkEmpty(data)) {
    ElMessage({
      message: "复制内容不能为空！",
      type: "warning"
    })
    return
  }
  let input = document.createElement('input');
  input.value = data;
  document.body.appendChild(input);
  input.select();
  document.execCommand("Copy");
  document.body.removeChild(input);
}

/**
 * 函数防抖
 */
function debounceFn(fn, time) {
  // 记录上一次的延时器
  var timer = null;
  var delay = time || 200;
  return function () {
    var args = arguments;
    var that = this;
    // 清除上一次延时器
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

// 函数节流
function throttle(fn, delay = 500) {
  let timer = null;
  return function () {
    var args = arguments;
    if (timer) {
      return;
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}

// 搜索关键词高亮显示
function brightKeyword(keyword, val) {
  if (val.indexOf(keyword) !== -1) {
    //判断这个字段中是否包含keyword
    //如果包含的话，就把这个字段中的那一部分进行替换成html字符
    return val.replace(
      keyword,
      `<span style='color:#FF6600'>${keyword}</span>`
    );
  } else {
    return val;
  }
}

// 省市区按照拼音排序分类
function pinyinSort(dataList, name) {
  let pinyin = require("js-pinyin");
  pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
  // let FristPin = ["A", "B", "C", "D", "E", "F", "G", "H", "I","J", "K", "L", "M", "N", "O","P", "Q", "R", "S", "T","U","V", "W", "X", "Y", "Z"];
  let pinList = {
    AToG: ["A", "B", "C", "D", "E", "F", "G"],
    HToK: ["H", "I", "J", "K"],
    LToS: ["L", "M", "N", "O", "P", "Q", "R", "S"],
    TToZ: ["T", "U", "V", "W", "X", "Y", "Z"],
  };
  let resList = {
    "A-G": [],
    "H-K": [],
    "L-S": [],
    "T-Z": [],
  };
  let cityArr = [];
  for (let i = 0; i < dataList.length; i++) {
    //遍历数组,拿到城市名称
    let cityName = dataList[i][name];
    //取全部城市的首字母
    let fristName = pinyin.getCamelChars(cityName).substring(0, 1); //这里截取首字母的第一位
    //给原json添加首字母键值对
    dataList[i].first = fristName;
    //放入新数组
    cityArr.push(dataList[i]);
  }
  let cityjson = cityArr;
  for (let key in cityjson) {
    if (pinList.AToG.indexOf(cityjson[key].first) > -1) {
      if (Array.isArray(cityjson[key]) && cityjson[key].length > 0) {
        for (let i = 0; i < cityjson[key].length; i++) {
          resList["A-G"].push(cityjson[key][i]);
        }
      } else {
        resList["A-G"].push(cityjson[key]);
      }
    } else if (pinList.HToK.indexOf(cityjson[key].first) > -1) {
      if (Array.isArray(cityjson[key]) && cityjson[key].length > 0) {
        for (let i = 0; i < cityjson[key].length; i++) {
          resList["H-K"].push(cityjson[key][i]);
        }
      } else {
        resList["H-K"].push(cityjson[key]);
      }
    } else if (pinList.LToS.indexOf(cityjson[key].first) > -1) {
      if (Array.isArray(cityjson[key]) && cityjson[key].length > 0) {
        for (let i = 0; i < cityjson[key].length; i++) {
          resList["L-S"].push(cityjson[key][i]);
        }
      } else {
        resList["L-S"].push(cityjson[key]);
      }
    } else if (pinList.TToZ.indexOf(cityjson[key].first) > -1) {
      if (Array.isArray(cityjson[key]) && cityjson[key].length > 0) {
        for (let i = 0; i < cityjson[key].length; i++) {
          resList["T-Z"].push(cityjson[key][i]);
        }
      } else {
        resList["T-Z"].push(cityjson[key]);
      }
    }
  }
  return resList;
}

// 国家按照拼音排序分类
function pinyinCountrySort(dataList, name) {
  let pinyin = require("js-pinyin");
  pinyin.setOptions({ checkPolyphone: false, charCase: 0 });
  let pinList = {
    AToG: ["A", "B", "C", "D", "E", "F", "G"],
    HToN: ["H", "J", "K", "L", "M", "N"],
    OToT: ["O", "P", "Q", "R", "S", "T"],
    UToZ: ["U", "V", "W", "X", "Y", "Z"],
  };
  let resList = {
    "A-G": [],
    "H-N": [],
    "O-T": [],
    "U-Z": [],
  };
  let cityArr = [];
  for (let i = 0; i < dataList.length; i++) {
    //遍历数组,拿到城市名称
    let cityName = dataList[i][name];
    //取全部城市的首字母
    let fristName = pinyin.getCamelChars(cityName).substring(0, 1); //这里截取首字母的第一位
    //给原json添加首字母键值对
    dataList[i].first = fristName;
    //放入新数组
    cityArr.push(dataList[i]);
  }
  let cityjson = cityArr;
  for (let key in cityjson) {
    if (pinList.AToG.indexOf(cityjson[key].first) > -1) {
      if (Array.isArray(cityjson[key]) && cityjson[key].length > 0) {
        for (let i = 0; i < cityjson[key].length; i++) {
          resList["A-G"].push(cityjson[key][i]);
        }
      } else {
        resList["A-G"].push(cityjson[key]);
      }
    } else if (pinList.HToN.indexOf(cityjson[key].first) > -1) {
      if (Array.isArray(cityjson[key]) && cityjson[key].length > 0) {
        for (let i = 0; i < cityjson[key].length; i++) {
          resList["H-N"].push(cityjson[key][i]);
        }
      } else {
        resList["H-N"].push(cityjson[key]);
      }
    } else if (pinList.OToT.indexOf(cityjson[key].first) > -1) {
      if (Array.isArray(cityjson[key]) && cityjson[key].length > 0) {
        for (let i = 0; i < cityjson[key].length; i++) {
          resList["O-T"].push(cityjson[key][i]);
        }
      } else {
        resList["O-T"].push(cityjson[key]);
      }
    } else if (pinList.UToZ.indexOf(cityjson[key].first) > -1) {
      if (Array.isArray(cityjson[key]) && cityjson[key].length > 0) {
        for (let i = 0; i < cityjson[key].length; i++) {
          resList["U-Z"].push(cityjson[key][i]);
        }
      } else {
        resList["U-Z"].push(cityjson[key]);
      }
    }
  }
  return resList;
}

// 深度克隆对象
function deepClone(obj) {
  var objClone = Array.isArray(obj) ? [] : {};
  if (obj && typeof obj === "object") {
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (obj[key] && typeof obj[key] === "object") {
          objClone[key] = deepClone(obj[key]);
        } else {
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
}

/**
 * 委托书类型
 * @param {*} val 
 */
function genWts(val) {
  let genWts = {
    1: 1, // 商标注册
    666: 1, // 商标注册
    736: 27, // 撤回商标注册
    10: 5, // 商标变更
    956: 29, // 撤回变更地址名义申请
    757: 6, // 变更代理人/文件接收人
    976: 30, // 撤回变更代理人/文件接收人
    6: 9, // 商标转让
    764: 33, // 撤回商标转让转移申请
    714: 24, // 补发商标注册证书
    737: 4, // 商标更正
    715: 18, // 商标注销
    8: 8, // 商标宽展
    7: 8, // 商标续展
    957: 32, // 撤回商标续展申请
    829: 35, // 撤回商标注销申请
    9: 10, // 商标使用许可备案
    833: 34, // 撤回商标使用许可备案
    977: 11, // 变更许可人被许可人名称备案
    832: 12, // 商标使用许可提前终止备案
    982: 26, // 出具优先权证明申请
    978: 24, // 马德里国际商标出具商标注册证明申请
    756: 7, // 删减商品项
    752: 23, // 补发变转续证明
    3: 19, // 撤三申请
    979: 19, // 撤三变更双方代理
    2: 1, // 驳回复审申请  委托模版2的第1个
    769: 1, // 驳回复审申请  委托模版2的第1个
    5: 1, // 无效宣告申请  委托模版2的第5个
    4: 2, // 异议申请
    54: 3, // 异议答辩
    55: 21, // 撤三答辩
    56: 1, // 无效宣告答辩  委托模版2的第5个，且增加答辩2字
  }
  return genWts[val];
}

/**
 * UUID
 */
function uuid() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}